import React from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

// importing all the pages
import HomePage from "../pages/HomePage";
import ItemDetails from "../pages/item-details";
import Login from "../pages/login";
import Signup from "../pages/signup";
import Contact from "../pages/contact";
import Addproject from "../pages/Addproject";
import ManageProject from "../pages/ManageProject";
import WalletConnect from "../pages/WalletConnect";
import { logoutUser } from "../redux/actions/auth";
import { connect } from "react-redux";
import ManageReview from "../pages/ManageReview";
import MyReview from "../pages/MyReview";



const PrivateRoute = ({ dispatch, component, ...rest }) => {
  if (!(JSON.parse(localStorage.getItem("authenticated")))) {
    dispatch(logoutUser());
    return (<Redirect to="/login" />)
  } else {
    return (
      <Route { ...rest } render={props => (React.createElement(component, props))} />
    );
  }
};

const MyRouts = ({dispatch}) => {
 
    return (
      <div>
        <Router>
          <Switch>
          <Route path="/admin" exact render={() => <Redirect to="/dashboard/addproject" />} />
            <Route exact path="/" component={HomePage} />
            <Route exact path="/project/:id" component={ItemDetails} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/wallteconnect" component={WalletConnect} />
            <PrivateRoute exact path="/dashboard/addproject" dispatch={dispatch} component={Addproject} />
            <PrivateRoute exact path="/dashboard/manageproject" dispatch={dispatch} component={ManageProject} />
            <PrivateRoute exact path="/dashboard/managereview" dispatch={dispatch} component={ManageReview} />
            <Route exact path="/myreview" component={MyReview} />
          </Switch>
        </Router>
      </div>
    );
  
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(MyRouts);